export default (obj) => {
  if (!obj) return true;
  if (Object.keys(obj).length === 0) return true;
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (obj[key]) return false;
  }
  return true; // If all values are empty strings, return true
};
